"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountingSave = accountingSave;
exports.accountingSubmit = accountingSubmit;
exports.addSendCost = addSendCost;
exports.addSendTaskLog = addSendTaskLog;
exports.auditSend = auditSend;
exports.auditSendCost = auditSendCost;
exports.cancelSend = cancelSend;
exports.checkRemindStatus = checkRemindStatus;
exports.confirmSubmitSendSolution = confirmSubmitSendSolution;
exports.deleteSend = deleteSend;
exports.exportPendingList = exportPendingList;
exports.exportSend = exportSend;
exports.exportSendList = exportSendList;
exports.getDesignAudit = getDesignAudit;
exports.getDesignAuditStatusCounts = getDesignAuditStatusCounts;
exports.getOrderSolutionsByIds = getOrderSolutionsByIds;
exports.getPendingSubmit = getPendingSubmit;
exports.getPendingTree = getPendingTree;
exports.getSendCost = getSendCost;
exports.getSendList = getSendList;
exports.getSendOrdersBySendId = getSendOrdersBySendId;
exports.getSendSolutionList = getSendSolutionList;
exports.getSendStatistics = getSendStatistics;
exports.getSendStatisticsV2 = getSendStatisticsV2;
exports.getSendTaskLog = getSendTaskLog;
exports.initiateOrderSolution = initiateOrderSolution;
exports.markRemindRead = markRemindRead;
exports.printSendSolution = printSendSolution;
exports.remindSend = remindSend;
exports.reserveSend = reserveSend;
exports.stockUpSendSolution = stockUpSendSolution;
exports.submitSend = submitSend;
exports.syncSolution = syncSolution;
exports.updateOrderSolutionSave = updateOrderSolutionSave;
exports.updateOrderSolutionSaveBatch = updateOrderSolutionSaveBatch;
exports.updateSendCost = updateSendCost;

var _request = _interopRequireDefault(require("@/utils/request"));

function getSendList(params) {
  return (0, _request.default)({
    url: 'api/send',
    method: 'get',
    params: params
  });
}

function getSendStatistics(params) {
  return (0, _request.default)({
    url: 'api/send/statistics',
    method: 'get',
    params: params
  });
}

function getSendStatisticsV2(params) {
  return (0, _request.default)({
    url: 'api/send/statistics/v2',
    method: 'get',
    params: params
  });
}

function getPendingTree(params) {
  return (0, _request.default)({
    url: 'api/send/pending-tree',
    method: 'get',
    params: params
  });
}

function getPendingSubmit(params) {
  return (0, _request.default)({
    url: 'api/send/pending-submit',
    method: 'get',
    params: params
  });
}

function cancelSend(id) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/cancel"),
    method: 'put'
  });
}

function auditSend(id) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/audit"),
    method: 'put',
    params: {
      priceStatus: 20
    }
  });
}

function submitSend(id, status, stepBack) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/status"),
    method: 'put',
    data: {
      status: status,
      stepBack: stepBack
    }
  });
}

function getSendCost(params) {
  return (0, _request.default)({
    url: 'api/send-cost',
    method: 'get',
    params: params
  });
}

function addSendCost(data) {
  return (0, _request.default)({
    url: 'api/send-cost',
    method: 'post',
    data: data
  });
}

function updateSendCost(data) {
  return (0, _request.default)({
    url: 'api/send-cost',
    method: 'put',
    data: data
  });
}

function auditSendCost(id, status, remark) {
  return (0, _request.default)({
    url: "api/send-cost/".concat(id, "/audit"),
    method: 'put',
    params: {
      status: status,
      remark: remark
    }
  });
}

function deleteSend(id) {
  return (0, _request.default)({
    url: "api/send/".concat(id),
    method: 'delete'
  });
}

function getSendTaskLog(params) {
  return (0, _request.default)({
    url: 'api/send-task-log',
    method: 'get',
    params: params
  });
}

function addSendTaskLog(data) {
  return (0, _request.default)({
    url: 'api/send-task-log',
    method: 'post',
    data: data
  });
}

function reserveSend(data) {
  return (0, _request.default)({
    url: 'api/send/reserve',
    method: 'post',
    data: data
  });
}

function syncSolution(params) {
  return (0, _request.default)({
    url: 'api/send/sync-solution',
    method: 'post',
    params: params
  });
}

function exportSend(id) {
  return (0, _request.default)({
    url: 'api/send/export',
    method: 'get',
    params: {
      id: id
    },
    responseType: 'blob'
  });
}

function exportSendList(params) {
  return (0, _request.default)({
    url: 'api/send/list-export',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

function exportPendingList(params) {
  return (0, _request.default)({
    url: 'api/send/pending-export',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

function remindSend(id) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/remind"),
    method: 'post'
  });
}

function checkRemindStatus(id, sendStatus) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/remind-status"),
    method: 'get',
    params: {
      sendStatus: sendStatus
    }
  });
}

function markRemindRead(id, sendStatus) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/remind-read"),
    method: 'put',
    params: {
      sendStatus: sendStatus
    }
  });
}

function updateOrderSolutionSave(orderSolutionId, saveData) {
  return (0, _request.default)({
    url: 'api/send/order-solution-save',
    method: 'put',
    params: {
      orderSolutionId: orderSolutionId,
      saveData: saveData
    }
  });
}

function updateOrderSolutionSaveBatch(data) {
  return (0, _request.default)({
    url: 'api/send/order-solution-save-batch',
    method: 'put',
    data: data
  });
}

function accountingSubmit(id, data) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/accounting-submit"),
    method: 'put',
    data: data
  });
}

function accountingSave(id, data) {
  return (0, _request.default)({
    url: "api/send/".concat(id, "/accounting-save"),
    method: 'put',
    data: data
  });
}

function getSendSolutionList(params) {
  return (0, _request.default)({
    url: 'api/send/send-solution',
    method: 'get',
    params: params
  });
}

function printSendSolution(data) {
  return (0, _request.default)({
    url: 'api/send/send-solution/print',
    method: 'put',
    data: data
  });
}

function stockUpSendSolution(data) {
  return (0, _request.default)({
    url: 'api/send/send-solution/stock-up',
    method: 'put',
    data: data
  });
}

function confirmSubmitSendSolution(data) {
  return (0, _request.default)({
    url: 'api/send/send-solution/confirm-submit',
    method: 'put',
    data: data
  });
}

function initiateOrderSolution(data) {
  return (0, _request.default)({
    url: 'api/send/send-solution/initiate',
    method: 'put',
    data: data
  });
}

function getDesignAudit(params) {
  return (0, _request.default)({
    url: 'api/send/design-audit',
    method: 'get',
    params: params
  });
}

function getDesignAuditStatusCounts() {
  return (0, _request.default)({
    url: 'api/send/design-audit/status-counts',
    method: 'get'
  });
}

function getOrderSolutionsByIds(ids) {
  return (0, _request.default)({
    url: 'api/send-order/order-solutions',
    method: 'get',
    params: {
      ids: ids.join(',')
    }
  });
}

function getSendOrdersBySendId(sendId) {
  return (0, _request.default)({
    url: 'api/send-order/by-send-id',
    method: 'get',
    params: {
      sendId: sendId
    }
  });
}